import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { JSONMap as r } from "../../core/jsonMap.js";
import { JSONSupport as o } from "../../core/JSONSupport.js";
import t from "../../core/Logger.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { cast as i } from "../../core/accessorSupport/decorators/cast.js";
import { subclass as p } from "../../core/accessorSupport/decorators/subclass.js";
import { ensureString as l } from "../../core/accessorSupport/ensureType.js";
import n from "./support/VisualVariableLegendOptions.js";
var a = t.getLogger("esri.renderers.visualVariables.VisualVariable"),
    u = new r({
  colorInfo: "color",
  transparencyInfo: "opacity",
  rotationInfo: "rotation",
  sizeInfo: "size"
});

var c = /*#__PURE__*/function (_o) {
  _inherits(c, _o);

  var _super = _createSuper(c);

  function c(e) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, e), _this.index = null, _this.type = null, _this.field = null, _this.valueExpression = null, _this.valueExpressionTitle = null, _this.legendOptions = null;
    return _this;
  }

  _createClass(c, [{
    key: "castField",
    value: function castField(e) {
      return null == e ? e : "function" == typeof e ? (a.error(".field: field must be a string value"), null) : l(e);
    }
  }, {
    key: "arcadeRequired",
    get: function get() {
      return !!this.valueExpression;
    }
  }, {
    key: "clone",
    value: function clone() {}
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return "".concat(this.type, "-").concat(this.field, "-").concat(this.valueExpression);
    }
  }]);

  return c;
}(o);

e([s()], c.prototype, "index", void 0), e([s({
  type: u.apiValues,
  readOnly: !0,
  json: {
    read: u.read,
    write: u.write
  }
})], c.prototype, "type", void 0), e([s({
  type: String,
  json: {
    write: !0
  }
})], c.prototype, "field", void 0), e([i("field")], c.prototype, "castField", null), e([s({
  type: String,
  json: {
    write: !0
  }
})], c.prototype, "valueExpression", void 0), e([s({
  type: String,
  json: {
    write: !0
  }
})], c.prototype, "valueExpressionTitle", void 0), e([s({
  readOnly: !0
})], c.prototype, "arcadeRequired", null), e([s({
  type: n,
  json: {
    write: !0
  }
})], c.prototype, "legendOptions", void 0), c = e([p("esri.renderers.visualVariables.VisualVariable")], c);
var d = c;
export { d as default };